import { render, staticRenderFns } from "./BlockType14Grid.vue?vue&type=template&id=2f64e390&scoped=true"
import script from "./BlockType14Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType14Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType14Grid.vue?vue&type=style&index=0&id=2f64e390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f64e390",
  null
  
)

export default component.exports